export default {
  'printer.title': '打印机',

  'printer.field.name': '打印机名',
  'printer.field.modelName': '型号',
  'printer.field.displayName': '显示名',
  'printer.field.responsibility': '描述',
  'printer.field.purpose': '用途',
  'printer.field.language': '菜品名语言',
  'printer.field.serviceType': '服务类型',
  'printer.field.orderSource': '订单来源',
  'printer.field.triggerToPrint': '打印触发时机',
  'printer.field.isOneDishOnePrint': '一菜一单',
  'printer.field.splitKitchenTicket': '拆分厨房小票',
  'printer.field.splitPackingTicket': '拆分外带单',

  'printer.action.enable': '启用打印机',
  'printer.action.disable': '停用打印机',

  'printer.enablePrinter.promptTitle': '打印机启用提示',
  'printer.enablePrinter.promptContent': '确定要启用此打印机吗 ?',
  'printer.disablePrinter.promptTitle': '打印机停用提示',
  'printer.disablePrinter.promptContent': '确定要停用打印机吗 ?',
};
